/* eslint-disable react-refresh/only-export-components -- thin gate module: closed-door copy + route wrapper */
import { Link, Navigate } from 'react-router-dom';
import { useProductDoor } from '../lib/productDoors';

export const BONK_LAB_UNAVAILABLE_TITLE = 'Bonk Lab is unavailable';
export const BONK_LAB_UNAVAILABLE_BODY =
  'This tool is not available right now. You can still review your Bonk Risk Index history.';
export const BONK_LAB_UNAVAILABLE_BACK_LABEL = 'Back to Bonk Risk Index';

export function FeatureDoorUnavailable({
  title,
  body,
  backTo,
  backLabel,
  testId = 'feature-door-unavailable',
}) {
  return (
    <div className="max-w-2xl mx-auto px-4 py-10" data-testid={testId}>
      <div className="bg-[var(--bg-card)] rounded-2xl p-8 shadow-sm text-center">
        <h1 className="text-xl font-display font-bold text-stone-900 dark:text-stone-100 mb-2">
          {title}
        </h1>
        <p className="text-sm text-stone-600 dark:text-stone-400 mb-6">{body}</p>
        <Link
          to={backTo}
          className="btn-primary inline-flex items-center justify-center px-6 py-3 text-sm font-semibold min-h-[44px]"
        >
          {backLabel}
        </Link>
      </div>
    </div>
  );
}

export function FeatureDoorRoute({ door, children, closedFallback = null }) {
  const open = useProductDoor(door);
  if (!open) {
    return closedFallback ?? <Navigate to="/dashboard" replace />;
  }
  return children;
}
